module.exports = __webpack_public_path__ + "static/Airbnb-c74a108a47b5a8ac04302a61f59002ec.jpg";